<template>
  <div>
    <calendar class="card card-body rounded-top" :events="events" @eventClick="showEventModal" />

    <event-modal :event="selectedEvent" :id="idToEdit" :show="showModal" @close="hideModal" @updated="refreshEvents" />
  </div>
</template>

<script>
import EventModal from '@/components/modals/EventModal';
import { calendarMixin } from '@/mixins/calendar';
import { beforeCalendarRoute } from '@/routesUtils/calendar';
import { tryParseInt } from '@/utils/number';
import { TableName } from '../../enums/tableName.enum';

// @vuese
// Kalendarz z wydarzeniami klubu
// @group Club
export default {
  components: { EventModal },
  mixins: [calendarMixin],
  beforeRouteUpdate(to, from, next) {
    beforeCalendarRoute(to, tryParseInt(to.params.clubId), TableName.Club, next);
  }
};
</script>
